export default __webpack_public_path__ + "static/media/img_shop-product03.140b5ea9.png";